/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { TouchableOpacity } from "react-native";

import { AutoLoadingVideoModal, SessionImage } from "UpduoLibrary";
import { SkaleSessionType } from "graphql/internal/generated";

export default function VideoModalLauncherIcon({
  session,
  onUpdateSession,
}: {
  session: Pick<
    SkaleSessionType,
    "id" | "thumbnailUrl" | "duration" | "archiveUrl"
  >;
  onUpdateSession?: (
    changes: Partial<
      Pick<SkaleSessionType, "isCancelled" | "allowSharing" | "masteryEdited">
    >
  ) => void;
}) {
  const [showArchiveVideo, setShowArchiveVideo] = useState<string | null>(null);
  if (!session.archiveUrl) {
    return null;
  }
  return (
    <>
      <TouchableOpacity
        style={{ alignItems: "center" }}
        onPress={() => {
          setShowArchiveVideo(session.id);
        }}
      >
        <SessionImage uri={session.thumbnailUrl} duration={session.duration} />
      </TouchableOpacity>
      {showArchiveVideo && (
        <AutoLoadingVideoModal
          sessionId={showArchiveVideo}
          onClose={() => setShowArchiveVideo(null)}
          onUpdateSession={onUpdateSession}
        />
      )}
    </>
  );
}
